import React, { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import AdministratorIcon from "@mui/icons-material/ManageAccounts";
import CompaniesIcon from "@mui/icons-material/Business";
import TemplatesIcon from "@mui/icons-material/PlaylistAddCheck";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { useTheme, useMediaQuery } from "@mui/material";

const AdministratorMenu = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const onMenuItemClick = (path) => {
    if (isMobile) {
      toggleDrawer();
    }
    startTransition(() => navigate(path));
  };

  return (
    <React.Fragment>
      <ListSubheader component="div" inset>
        Administrator
      </ListSubheader>
      <ListItemButton onClick={() => onMenuItemClick(`/administrators`)}>
        <ListItemIcon>
          <AdministratorIcon />
        </ListItemIcon>
        <ListItemText primary="Administrators" />
      </ListItemButton>
      <ListItemButton onClick={() => onMenuItemClick(`/publicusers`)}>
        <ListItemIcon>
          <AdministratorIcon />
        </ListItemIcon>
        <ListItemText primary="Public Users" />
      </ListItemButton>
      <ListItemButton onClick={() => onMenuItemClick(`/companies`)}>
        <ListItemIcon>
          <CompaniesIcon />
        </ListItemIcon>
        <ListItemText primary="Companies" />
      </ListItemButton>
      <ListItemButton onClick={() => onMenuItemClick(`/upload-user-manual`)}>
        <ListItemIcon>
          <MenuBookIcon />
        </ListItemIcon>
        <ListItemText primary="User Manual" />
      </ListItemButton>
      <ListItemButton onClick={() => onMenuItemClick(`/tender-templates`)}>
        <ListItemIcon>
          <TemplatesIcon />
        </ListItemIcon>
        <ListItemText primary="Tender templates" />
      </ListItemButton>
      <ListItemButton onClick={() => onMenuItemClick(`/contract-templates`)}>
        <ListItemIcon>
          <TemplatesIcon />
        </ListItemIcon>
        <ListItemText primary="Contract templates" />
      </ListItemButton>
      <ListItemButton onClick={() => onMenuItemClick(`/public-templates`)}>
        <ListItemIcon>
          <TemplatesIcon />
        </ListItemIcon>
        <ListItemText primary="Public templates" />
      </ListItemButton>
      <ListItemButton onClick={() => onMenuItemClick(`/other-templates`)}>
        <ListItemIcon>
          <TemplatesIcon />
        </ListItemIcon>
        <ListItemText primary="Other templates" />
      </ListItemButton>
    </React.Fragment>
  );
};

export default AdministratorMenu;
